import React from 'react'
import { DoorPropertiesProps } from './types'
import {
  PropertySection,
  SectionHeader,
  SectionTitle,
  CollapseIcon,
  SectionContent,
  PropertyGroup,
  Label,
  Input,
  InfoText,
  Select,
  Checkbox,
} from '../styled'
import {
  realToPixels,
  getUnitSingular,
  getDefaultDoorWidth,
  getDefaultDoorHeight,
  formatStandardDoorWidth,
  formatStandardDoorHeight,
} from '../helpers'

const DoorProperties: React.FC<DoorPropertiesProps> = ({
  selectedElement,
  mapSettings,
  localProperties,
  isCollapsed,
  onToggleSection,
  updateProperty,
  updateMeasurement,
  onUpdateElement,
}) => {
  return (
    <PropertySection>
      <SectionHeader isCollapsed={isCollapsed} onClick={onToggleSection}>
        <SectionTitle>Door Properties</SectionTitle>
        <CollapseIcon isCollapsed={isCollapsed}>▼</CollapseIcon>
      </SectionHeader>
      <SectionContent isCollapsed={isCollapsed}>
        <PropertyGroup>
          <Label>Door Width ({getUnitSingular(mapSettings)})</Label>
          <Input
            type="number"
            step="0.1"
            value={(
              selectedElement.measurements?.realWidth ||
              getDefaultDoorWidth(mapSettings)
            ).toFixed(1)}
            onChange={e => {
              const realWidth = Number(e.target.value)
              updateMeasurement('realWidth', realWidth)
              updateProperty('width', realToPixels(realWidth, mapSettings))
            }}
          />
          <InfoText>Standard: {formatStandardDoorWidth(mapSettings)}</InfoText>
        </PropertyGroup>
        <PropertyGroup>
          <Label>Door Height ({getUnitSingular(mapSettings)})</Label>
          <Input
            type="number"
            step="0.1"
            value={(
              selectedElement.measurements?.realHeight ||
              getDefaultDoorHeight(mapSettings)
            ).toFixed(1)}
            onChange={e =>
              updateMeasurement('realHeight', Number(e.target.value))
            }
          />
          <InfoText>Standard: {formatStandardDoorHeight(mapSettings)}</InfoText>
        </PropertyGroup>
        <PropertyGroup>
          <Label>Door Type</Label>
          <Select
            value={localProperties.doorType || 'single'}
            onChange={e => updateProperty('doorType', e.target.value)}>
            <option value="single">Single Door</option>
            <option value="double">Double Door</option>
            <option value="sliding">Sliding Door</option>
            <option value="folding">Bi-fold Door</option>
            <option value="pocket">Pocket Door</option>
          </Select>
        </PropertyGroup>
        <PropertyGroup>
          <Label>Swing Direction</Label>
          <Select
            value={localProperties.swingDirection || 'inward'}
            onChange={e => updateProperty('swingDirection', e.target.value)}>
            <option value="inward">Inward</option>
            <option value="outward">Outward</option>
          </Select>
        </PropertyGroup>
        <PropertyGroup>
          <Label>Material</Label>
          <Select
            value={localProperties.material || 'wood'}
            onChange={e => updateProperty('material', e.target.value)}>
            <option value="wood">Wood</option>
            <option value="glass">Glass</option>
            <option value="metal">Metal</option>
            <option value="composite">Composite</option>
          </Select>
        </PropertyGroup>
        <PropertyGroup>
          <Label>Door Label</Label>
          <Input
            value={localProperties.label || ''}
            onChange={e => updateProperty('label', e.target.value)}
            placeholder="e.g., Main Entrance, Back Door"
          />
        </PropertyGroup>
        <PropertyGroup>
          <Label>
            <Checkbox
              checked={selectedElement.locked || false}
              onChange={e =>
                onUpdateElement(selectedElement.id, {
                  locked: e.target.checked,
                })
              }
            />
            Lock from Dragging
          </Label>
        </PropertyGroup>
      </SectionContent>
    </PropertySection>
  )
}

export { DoorProperties }
